import { assetPrefix } from 'config/env_config'
import { PET_TYPES } from '@cobasi/cobasi-utils/constants'

export const imageReferences = {
  COBASI_LOGO: `${assetPrefix}/static/images/cobasi.svg`,
  COBASI_DOG: `${assetPrefix}/static/icons/dog-default-icon.svg`
}

export const getPetPhotoByType = (type) => {
  switch (type) {
    case PET_TYPES.CAT:
      return `${assetPrefix}/static/icons/cat-default-icon.svg`
    case PET_TYPES.FERRET:
      return `${assetPrefix}/static/icons/rabbit-default-icon.svg`
    case PET_TYPES.PIGGY_INDIAN:
      return `${assetPrefix}/static/icons/ginea-pig-default-icon.svg`
    case PET_TYPES.RABBIT:
      return `${assetPrefix}/static/icons/rabbit-default-icon.svg`
    case PET_TYPES.DOG:
      return `${assetPrefix}/static/icons/dog-default-icon.svg`
    default:
      return `${assetPrefix}/static/icons/dog-default-icon.svg`
  }
}

export const getServiceIconByName = (serviceName, type) => {
  const getPath = (iconName) => `${assetPrefix}/static/icons/${iconName}${type ? `-${type}` : ''}.svg`
  switch (serviceName) {
    case 'Banho':
      return getPath('bath-new')
    case 'Banho&Tosa Higiênica':
      return getPath('bath-shave-new')
    case 'Banho&Tosa Máquina':
      return getPath('bath-shear-new')
    case 'Banho&Tosa Trimming':
      return getPath('bath-trimming-new')
    case 'Banho&Tosa Tesoura':
      return getPath('bath-scissors-new')
    case 'Banho&Hidratação':
      return getPath('bath-hidratation-new')
    case 'Consulta Dermatológica':
      return getPath('paw-new')
    case 'Acessórios':
      return getPath('acessories')
    case 'Alimentação':
      return getPath('alimentation')
    case 'Farmácia':
      return getPath('pharmacy')
    case 'Escovação de dentes':
      return getPath('additional-toothbrush')
    case 'Hidratação':
      return getPath('additional-hidratation')
    case (serviceName?.match(/Pacote/i) || {}).input:
      return getPath('bath-new')
    case 'Todos':
      return getPath('additional-all')
    case 'Outros':
      return getPath('other-service')
    case (serviceName?.match(/Vacina/) || {}).input:
      return getPath('vaccine-new')
    case (serviceName?.match(/Consulta/) || {}).input:
      return getPath('doctor-new')
    case (serviceName?.match(/Atestado/) || {}).input:
      return getPath('health-certificate')
    default:
      return getPath('bath-shave')
  }
}

export const getCreditCardBrandIcon = (brand) => {
  switch (brand) {
    case 'MASTER':
      return `${assetPrefix}/static/icons/brands/master.svg`
    case 'VISA':
      return `${assetPrefix}/static/icons/brands/visa.svg`
    case 'ELO':
      return `${assetPrefix}/static/icons/brands/elo.svg`
    default:
      return `${assetPrefix}/static/icons/master.svg`
  }
}
